import { JobHeader } from "../components/JobHeader";
import parse from "html-react-parser";
import ScrollToTop from "../../home/components/ScrollToTop";
import { useContext, useState, useEffect } from "react";
import { Store } from "../../../context/store";
import { apiHandler } from "../../../service/apiHelper";
import { Vacancy } from "../../home/models/Vacancies";
import { useLocation } from "react-router";
import { Transition } from "@headlessui/react";
import { RaceBy } from "@uiball/loaders";
import { ErrorElement, PageError } from "../../error/ErrorPage";
import { APICompletion } from "../../../service/apiHelper";
import { ApplyPage } from "./ApplyPage";
import { Link } from "react-router-dom";

export const JobDetails = () => {
  const store = useContext(Store);
  const location = useLocation();
  const [isLoading, setIsLoading] = useState(true);
  const [vacancy, setVacancy] = useState<Vacancy>();
  const [apiResponse, setApiResponse] = useState<APICompletion>();
  const [errorObj, setPageError] = useState<PageError>({
    code: "404",
    copy: "This page does not exist or is no longer available",
    codeDescription: "Page not found",
    cta: {
      label: "View open positions",
      link: `/${store.code}`,
    },
  });

  const headers = {
    "x-api-key": store.apiKey,
  };

  const getVacancy = async () => {
    const vacancyId = location.pathname.split("/")[2];
    const api = await apiHandler({
      url: `https://artemisapi.hr-flex.com/api/v1/clients/${store.code}/jobs/${vacancyId}`,
      method: "GET",
      headers: headers,
    });

    if (api.success) {
      let response = api.data as Vacancy;
      setVacancy(response);
    } else {
      if (api.status !== 404) {
        setPageError({
          code: `${api.status}`,
          copy: api.errorMessage ?? "",
          codeDescription: "Something went wrong",
        });
      }
    }
    setApiResponse(api);
    setIsLoading(false);
  };

  useEffect(() => {
    getVacancy();
  }, []);

  return (
    <>
      {isLoading ? (
        <div className="flex items-center justify-center h-screen space-y-6 my-14 ">
          <RaceBy size={120} lineWeight={5} speed={1.4} color="#3F52E3" />
        </div>
      ) : apiResponse?.success === false ? (
        <ErrorElement error={errorObj} />
      ) : (
        <Transition
          show={!isLoading}
          appear={true}
          as="div"
          enter="transition ease-out duration-300"
          enterFrom="transform opacity-0 scale-95"
          enterTo="transform opacity-100 scale-100"
          leave="transition ease-in duration-75"
          leaveFrom="transform opacity-100 scale-100"
          leaveTo="transform opacity-0 scale-95"
        >
          <div className="flex flex-col justify-between ">
            <div className="max-w-3xl px-4 mx-auto mt-8">
              <JobHeader vacancy={vacancy!} />
              <ScrollToTop />
              <section
                id="post-details"
                className="w-full mt-6 space-y-6 text-base leading-7 text-gray-700"
              >
                {parse(vacancy?.description ?? "")}
                <ApplyPage vacancy={vacancy!} />
              </section>
            </div>

            <div className="w-full py-6 text-center rounded-sm bg-gray-50">
              <Link
                to={store.company?.careersListingUrl ?? ""}
                className="text-sm hover:rounded-md hover:text-primary-900 text-primary-700 hover:p-2 hover:bg-primary-5 "
              >
                View Open Positions
              </Link>
            </div>
          </div>
        </Transition>
      )}
    </>
  );
};
